module.exports = __webpack_public_path__ + "media/honey-icons/icon-copy-7724ac74.svg";